import React from 'react';
import { getPolyglot } from '../../../../../../../i18n';
import Link from '../../../../../../../theme/components/Link';
import { StyledMenuItemPrimary } from '../../../../../../../components/App/header/AvatarMenu/AvatarMenu';
import { isSCCManager } from '../../../../../redux/rights/selectors/roles';
import { useAppSelector } from '../../../../../../../redux/store.model';

export const FreshwatchAppMenuLinks = (props: {
  listApps: string[];
  handleClose: () => void;
}) => {
  const { listApps, handleClose } = props;

  const polyglot = getPolyglot();

  const isAdmin = useAppSelector(isSCCManager);
  const updatedListApps = listApps.map((stringApp: string) => {
    if (stringApp === 'storelist' && isAdmin) {
      return 'companies';
    }
    return stringApp;
  });
  return updatedListApps.map((stringApp: string) => (
    <Link to={`/${stringApp}`} onClick={handleClose} key={stringApp}>
      <StyledMenuItemPrimary>
        {polyglot.t(`nav.menu.${stringApp}`)}
      </StyledMenuItemPrimary>
    </Link>
  ));
};
